import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBuildId } from '../utils/buildInfo';

const currentYear = new Date().getFullYear();
const Footer: React.FC = () => {
  const [buildId, setBuildId] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getBuildId()
      .then((id) => {
        if (!cancelled) setBuildId(id);
      })
      .catch(() => {
        if (!cancelled) setBuildId(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const buildIdShort = buildId ? buildId.slice(0, 7) : null;

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="footer-logo-container">
            <div className="footer-logo-symbol">
              <span className="footer-logo-symbol-text">C</span>
            </div>
            <span className="footer-logo">Cognidaily</span>
          </div>
          <p>
            The platform for seriously competitive learners.
          </p>
        </div>
        <div className="footer-links">
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>
      <div className="container footer-meta">
        <div className="footer-meta-row">
          <p className="footer-copyright">
            © {currentYear} Cognidaily. All rights reserved.
            {buildIdShort && (
              <span className="footer-build-id" title={buildId ?? undefined}>
                Build {buildIdShort}
              </span>
            )}
          </p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <span className="footer-separator">|</span>
            <Link to="/terms-of-service">Terms of Service</Link>
            <span className="footer-separator">|</span>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <span className="footer-separator">|</span>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;




